export var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum["INFO"] = "INFO";
    NotificationTypeEnum["SUCCESS"] = "SUCCESS";
    NotificationTypeEnum["ERROR"] = "ERROR";
    NotificationTypeEnum["WARNING"] = "WARNING";
    NotificationTypeEnum["CRITICAL"] = "CRITICAL";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));
